

























































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {SelectBox, TaskInfoCalc} from '@/interfaces/global-data';
import {GetTaskInfo, TaskInfoFilterType} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import ModuleApi from '@/pages/ModuleItems/ModuleApi';
import {Component, Mixins, Model, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import { IModuleItemFilters } from "@/pages/ModuleItems/data";

@Component({
    components: {
        MarketSelect,
        MultiSelect,
        vSelect,
        Card,
        CollapseCard,
    },
})
export default class ItemFilters extends Mixins(LocalData, Http) {
    @Model() value!: IModuleItemFilters;
    @Prop({required: true}) readonly api!: ModuleApi;

    private taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        buyerSegmentOptions: [],
        categoryOptions: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        clusterOptions: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        groupsOfProduct: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: -1, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };

    private defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('shared.selectBox.all') as string}];

    private isFormatLoading = false;
    private isRegionLoading = false;
    private isClusterLoading = false;

    mounted() {
        if (!this.value.market || this.value.market.id === -1) {
            return;
        }

        (this.$refs.groupsOfProductRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.categoriesOfProductRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.clusterSelectedRef as any).toggleLoading(true);

        this.getCategoryInfo(() => {
            this.getRegionInfo();
            this.getFormatInfo();
            this.getClusterInfo();
            this.loadProductsGroup();
            this.loadProductsSubcategories();
        });
    }

    private get isGroupsSelected(): boolean {
        return !!(this.value.groupIds.length && this.value.groupIds[0] !== -1);
    }

    private get isCategoriesSelected(): boolean {
        return !!(this.value.categoryIds.length && this.value.categoryIds[0] !== -1);
    }

    private recalculateSetState() {
        const isFiltersSelected = this.value.market != null && this.value.market.id > 0;
        this.$emit('onFiltersSelecting', isFiltersSelected);
    }

    private get isFormatSelected(): boolean {
        if (this.isFormatLoading) {
            return false;
        }
        if (this.taskInfo.storeFormatOptions == null
                || (this.taskInfo.storeFormatOptions.length === 1 && this.taskInfo.storeFormatOptions[0].value === -1)) {
            return true
        }
        return this.value.formatSelected != null && this.value.formatSelected > 0
    }

    private get isRegionSelected(): boolean {
        if (this.isRegionLoading) {
            return false;
        }
        if (this.taskInfo.storeRegionOptions == null
                || (this.taskInfo.storeRegionOptions.length === 1 && this.taskInfo.storeRegionOptions[0].value === -1)) {
            return true
        }

        return !!this.value.regionIds.length && this.value.regionIds[0] !== -1;
    }

    private getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.categoriesOfProductRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.categories.length > 0) {
                        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.categoryOptions.unshift({
                            value: -1,
                            label: this.$t('shared.selectBox.all') as string,
                        });
                    } else {
                        this.value.categoryIds = [];
                        this.taskInfo.categoryOptions = [{
                            value: -1,
                            label: this.$t('shared.selectBox.all') as string,
                        }];
                        this.resetData(TaskInfoFilterType.category);
                    }
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    private loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupsOfProductRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.groups.length > 0) {
                        this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.groupsOfProduct.unshift({value: -1, label: this.$t('shared.selectBox.all') as string});
                    } else {
                        this.value.groupIds = [];
                        this.taskInfo.groupsOfProduct = [{value: -1, label: this.$t('shared.selectBox.all') as string}];
                    }
                })
                .catch((e) => {
                })
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const market = this.value.market;
        if (market == null) {
            return {
                type: taskType,
                tradingId: 1,
                categories: [],
                groups: [],
                subcategory: null,
                segments: null,
                storeFormat: null,
                storeCluster: null,
                storeRegion: null,
                byReports: false,
            }
        }
        return {
            type: taskType,
            tradingId: market.id,
            categories: LocalData.filterNumberArrays(this.value.categoryIds),
            groups: LocalData.filterNumberArrays(this.value.groupIds),
            subcategory: this.value.subcategory == null || this.value.subcategory <= 0
                    ? null
                    : [this.value.subcategory as number],
            segments: null,
            storeFormat: this.value.formatSelected == null || this.value.formatSelected <= 0 ? [] : [this.value.formatSelected],
            storeCluster: this.value.clusterIds.length && this.value.clusterIds[0] === -1 ? [] : this.value.clusterIds,
            storeRegion: this.value.regionIds.length && this.value.regionIds[0] === -1 ? [] : this.value.regionIds,
            byReports: false,
        }
    }

    private resetData(type: TaskInfoFilterType) {
        switch (type) {
            // all "value" to emit
            case TaskInfoFilterType.group:
                this.value.categoryIds = [];
                this.value.subcategory = -1;
                this.taskInfo.categoryOptions = this.defaultIntSelectBox;
                this.taskInfo.subcategories = this.defaultIntSelectBox;
                this.value.formatSelected = -1;
                this.value.regionIds = [];
                this.value.clusterIds = [];
                (this.$refs.categoriesOfProductRef as any).toggleLoading(true);
                (this.$refs.subcategoriesRef as any).toggleLoading(true);
                (this.$refs.formatSelectedRef as any).toggleLoading(true);
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.clusterSelectedRef as any).toggleLoading(true);
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo()
                break;
            case TaskInfoFilterType.category:
                this.value.subcategory = -1;
                this.taskInfo.subcategories = this.defaultIntSelectBox;
                this.value.formatSelected = -1;
                this.value.regionIds = [];
                this.value.clusterIds = [];
                (this.$refs.subcategoriesRef as any).toggleLoading(true);
                (this.$refs.formatSelectedRef as any).toggleLoading(true);
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.clusterSelectedRef as any).toggleLoading(true);
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo()
                break;
            case TaskInfoFilterType.subcategory:
                this.value.formatSelected = -1;
                this.value.regionIds = [];
                this.value.clusterIds = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = this.defaultIntSelectBox;
                this.taskInfo.storeRegionOptions = this.defaultIntSelectBox;
                this.taskInfo.clusterOptions = this.defaultIntSelectBox;
                (this.$refs.formatSelectedRef as any).toggleLoading(true);
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.clusterSelectedRef as any).toggleLoading(true);
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.value.regionIds = [];
                this.value.clusterIds = [];
                this.taskInfo.storeRegionOptions = this.defaultIntSelectBox;
                this.taskInfo.clusterOptions = this.defaultIntSelectBox;
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.clusterSelectedRef as any).toggleLoading(true);
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.value.clusterIds = [];
                this.taskInfo.clusterOptions = this.defaultIntSelectBox;
                (this.$refs.clusterSelectedRef as any).toggleLoading(true);
                this.getClusterInfo();
                break;
        }
    }

    private loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;

                    this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.subcategories.unshift({value: -1, label: this.$t('shared.selectBox.all') as string})
                    setTimeout(() => {
                        (this.$refs.subcategoriesRef as any).toggleLoading(false);
                    }, 250);
                })
                .catch((e) => {
                })
    }

    private updateProductGroups(ids: number[]) {
        if (!!ids.length && !LocalData.compareTwoArrays(ids, this.value.groupIds)) {
            this.value.groupIds = ids.realValuesOrEmpty();

            this.resetData(TaskInfoFilterType.group);
        }
    }

    private updateProductCategories(ids: number[]) {
        if (!!ids.length && !LocalData.compareTwoArrays(ids, this.value.categoryIds)) {
            this.value.categoryIds = ids.realValuesOrEmpty();

            this.resetData(TaskInfoFilterType.category);
        }
    }

    private updateSubcategories(subcategory: number) {
        this.value.subcategory = subcategory;
    }

    private updateFormat(format: number) {
        if (format !== this.value.formatSelected) {
            this.value.formatSelected = format;
            this.resetData(TaskInfoFilterType.format);
        }
    }

    private getFormatInfo() {
        this.isFormatLoading = true;
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.storeFormatOptions = [{
                        value: -1,
                        label: this.$t('shared.selectBox.all') as string,
                    },
                        ...filterData.storeFormat.map((i) => {
                            return {value: i.id, label: i.name};
                        })];
                    this.isFormatLoading = false;
                    this.recalculateSetState();
                })
                .catch((e) => {
                });

    }

    updateRegions(ids: number[]) {
        if (!!ids.length && !LocalData.compareTwoArrays(ids, this.value.regionIds)) {
            this.value.regionIds = ids.realValuesOrEmpty();

            this.resetData(TaskInfoFilterType.region);
        }
    }

    private getRegionInfo() {
        this.isRegionLoading = true;
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = [{
                        value: -1,
                        label: this.$t('shared.selectBox.all') as string,
                    }, ...filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    })];
                    this.isRegionLoading = false;
                    this.recalculateSetState();
                })
                .catch((e) => {
                });
    }

    updateClusters(ids: number[]) {
        if (!!ids.length && !LocalData.compareTwoArrays(ids, this.value.clusterIds)) {
            this.value.clusterIds = ids.realValuesOrEmpty();

            this.resetData(TaskInfoFilterType.cluster);
        }
    }

    private getClusterInfo() {
        this.isClusterLoading = true;
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clusterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = [{
                        value: -1,
                        label: this.$t('shared.selectBox.all') as string,
                    },
                        ...filterData.storeCluster.map((i) => {
                            return {value: i.id, label: i.name};
                        })];
                    this.isClusterLoading = false;
                    this.recalculateSetState();
                })
                .catch((e) => {
                });
    }
}

